import { createSlice } from '@reduxjs/toolkit'

const DEFAULT_INITIAL_STATE = {
    data: {
        slice: 25,
        page: 0,
        count: 0,
        values: [],
        loading: false,
        error: null
    }
}

const reducers = (storeName, extraActions) => {
    const reducers = {}
    reducers[`${storeName}GetListDataAction`] = (state) => {
        state.data.values = []
    }
    reducers[`${storeName}SetListDataAction`] = (state, action) => {
        state.data.values = action.values
        state.data.count = action.count
    }
    reducers[`${storeName}SetPageAction`] = (state, action) => {
        state.data.page = action.payload.page
    }
    reducers[`${storeName}SetSliceAction`] = (state, action) => {
        state.data.slice = action.payload.slice
    }
    reducers[`${storeName}Error`] = (state, action) => {
        state.data.error = action.payload
    }
    if (extraActions) {
        for (const index in extraActions) {
            const extraAction = extraActions[index]
            reducers[`${storeName}${extraAction.name}`] = extraAction.reducer
        }
    }
    return reducers
}

export const createPaginatedListSlice = (
    storeName,
    extraActions,
    initialState = DEFAULT_INITIAL_STATE,
) => createSlice({
    name: storeName,
    initialState: initialState,
    reducers: reducers(storeName, extraActions)
})
